import {Component, Inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {User} from "../../../models/user";
import {Router} from "@angular/router";
import {FuseTranslationLoaderService} from "../../../../../@fuse/services/translation-loader.service";
import {locale as polish} from './../i18n/pl';

@Component({
    selector: 'user-workout-details-modal-component',
    templateUrl: './userWorkoutDetailsModal.component.html',
    styleUrls: ['./userWorkoutDetailsModal.component.scss']
})
export class UserWorkoutDetailsModalComponent {
    public user: User;
    public deviceName: string;

    constructor(
        public dialogRef: MatDialogRef<UserWorkoutDetailsModalComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private router: Router,
        private translationLoader: FuseTranslationLoaderService
    ) {
        this.user = _data.user;
        this.deviceName = _data.deviceName;
        this.translationLoader.loadTranslations(polish);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    goToCustomerDetails(): void {
        this.dialogRef.close();
        this.router.navigate(['/customers/details', this.user.id]);
    }

    getAge(): number | null {
        if (!this.user.birthday) {
            return null;
        }
        const birthday = new Date(this.user.birthday);
        const today = new Date();
        let age = today.getFullYear() - birthday.getFullYear();
        const monthDiff = today.getMonth() - birthday.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthday.getDate())) {
            age--;
        }
        return age;
    }

    formatBirthday(): string | null {
        if (!this.user.birthday) {
            return null;
        }
        const date = new Date(this.user.birthday);
        return date.toLocaleDateString('pl-PL');
    }
}